require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/core-js/modules/es7.symbol.observable.js
// module id = 1011
// module chunks = 0